var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"photos-empty"},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"content"},[_c('icon',{staticClass:"icon",attrs:{"name":"no-media-image"}}),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t("identity_data.no_photos")))])],1)]),_c('div',{staticClass:"footer"})])
}
var staticRenderFns = []

export { render, staticRenderFns }